export default function ApprovalEmail({
  fullName,
  businessName,
}: {
  fullName: string;
  businessName: string;
}) {
  return `
  <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 40px 0;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
      <div style="background-color: #E95B0C; padding: 20px; text-align: center;">
        <h1 style="color: #ffffff; margin: 0; font-size: 22px;">Feria de Emprendedores 2025 UAT-UAMVH</h1>
      </div>

      <div style="padding: 30px;">
        <p style="font-size: 16px; color: #333;">Hola <strong>${fullName}</strong>,</p>

        <p style="font-size: 15px; color: #333; line-height: 1.6;">
          ¡Felicidades! Nos complace informarte que tu solicitud para participar como expositor en la
          <strong>Feria de Emprendedores 2025 UAT-UAMVH</strong> ha sido <strong>aprobada</strong>.
        </p>

        <div style="background-color: #fff6f0; border-left: 4px solid #E95B0C; padding: 16px; margin: 24px 0; border-radius: 6px;">
          <h3 style="margin: 0 0 10px; color: #E95B0C; font-size: 16px;">Detalles de tu participación:</h3>
          <p style="margin: 0; font-size: 15px; color: #444; line-height: 1.6;">
            Proyecto: <strong>${businessName}</strong><br/>
            Modalidad: <strong>Expositor aprobado</strong><br/>
            Documentos adjuntos: <strong>Carta de aprobación</strong> y <strong>cartel oficial del stand</strong>.
          </p>
        </div>

        <p style="font-size: 15px; color: #333; line-height: 1.6;">
          Te recomendamos revisar los archivos adjuntos cuidadosamente, ya que contienen información importante
          sobre los lineamientos del evento, así como el diseño asignado para tu stand.
        </p>

        <p style="font-size: 15px; color: #333; line-height: 1.6;">
          Agradecemos tu entusiasmo y compromiso con esta iniciativa universitaria que impulsa la creatividad y el talento emprendedor.
        </p>

        <div style="text-align: center; margin-top: 30px;">
          <a href="https://feriadeemprendedoresuat.site/"
             style="background-color: #E95B0C; color: white; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: bold;">
            Visitar sitio web
          </a>
        </div>

        <p style="font-size: 13px; color: #777; margin-top: 40px; text-align: center;">
          Atentamente,<br/>
          <strong>Comité Organizador - Feria de Emprendedores 2025 UAT-UAMVH</strong><br/>
          Universidad Autónoma de Tamaulipas
        </p>
      </div>
    </div>
  </div>`;
}
